import React from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from 'reactstrap';
import Icon from 'components/Icon';
import { useAdminCustomer } from 'contexts/adminCustomer';
import classNames from 'classnames';

const CustomerSelector = () => {
  const {
    activeCustomer,
    setActiveCustomer,
    clearActiveCustomer,
    customers,
    isLoadingCustomers,
    isAdmin
  } = useAdminCustomer();

  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  if (!isAdmin) {
    return null;
  }

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} className="me-3">
      <DropdownToggle
        color="none"
        className={classNames(
          'd-flex align-items-center border rounded-pill px-3 py-1',
          activeCustomer ? 'border-primary' : 'border-warning'
        )}
      >
        <Icon
          icon="building"
          className={activeCustomer ? 'text-primary' : 'text-warning'}
          width={18}
          height={18}
        />
        <span className="ms-2 small">
          {isLoadingCustomers
            ? 'Carregando...'
            : activeCustomer
            ? activeCustomer.name
            : 'Selecione um cliente'}
        </span>
        <Icon icon="chevron-down" className="ms-2" width={14} height={14} />
      </DropdownToggle>
      <DropdownMenu
        className="dropdown-menu-end"
        style={{ maxHeight: '300px', overflowY: 'auto' }}
      >
        <DropdownItem header>Selecionar Cliente</DropdownItem>
        <DropdownItem divider />
        {activeCustomer && (
          <>
            <DropdownItem onClick={clearActiveCustomer}>
              <Icon icon="x-circle" className="me-2 text-danger" />
              Limpar seleção
            </DropdownItem>
            <DropdownItem divider />
          </>
        )}
        {customers.length > 0 ? (
          customers.map((customer) => (
            <DropdownItem
              key={customer.id}
              active={activeCustomer?.id === customer.id}
              onClick={() => setActiveCustomer(customer)}
            >
              <Icon icon="building" className="me-2" />
              {customer.name}
            </DropdownItem>
          ))
        ) : (
          <DropdownItem disabled>Nenhum cliente disponível</DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default CustomerSelector;
